import Button from '@atlaskit/button/standard-button';
import AKFeedbackCollector from '@atlaskit/feedback-collector';
import { AutoDismissFlag, FlagGroup } from '@atlaskit/flag';
import SuccessIcon from '@atlaskit/icon/glyph/check-circle';
import { useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { useUserDetails } from '@atlassian/mpac-ui';
import { DOMUtils } from '@atlassian/mpac-utils';
import React, { useState } from 'react';
import { openFeedbackCollectorEventFields, submitFeedbackCollectorEventFields } from './PartnerFeedback.events';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/*
 Customer feedback gets funneled into the customer feedback project.
 https://customerfeedback.atlassian.net/jira/servicedesk/projects/MPRV2/queues/custom/815

 Project name: Marketplace partner reports v2
 Slack link: https://atlassian.slack.com/archives/CFNR0H874/p1676314301025399?thread_ts=1676312670.945929&cid=CFNR0H874
 */
//
export const ENTRYPOINT_ID = '98f371a6-a496-46c6-ae65-e954e7e4e0d9';
const FeedbackPreamble = () => /*#__PURE__*/_jsx("div", {
  style: {
    paddingBottom: '0.5em'
  },
  "data-testid": "feedback-collector-preamble",
  children: /*#__PURE__*/_jsx("p", {
    children: "Your thoughts are valuable in helping improve the partner experience."
  })
});
const PartnerFeedback = props => {
  const {
    enableAppificationChanges
  } = useStatsig();
  const {
    mpacBaseUrl,
    attributes
  } = props;
  const [isFeedbackCollectorOpen, setFeedbackCollectorOpen] = useState(false);
  const [isFlagOpen, setFlagOpen] = useState(false);
  const userDetails = useUserDetails();
  const fireAnalyticsEvent = useAnalyticsEvents();
  const additionalFields = [{
    id: 'customfield_10047',
    value: attributes
  }];
  const giveFeedback = () => {
    fireAnalyticsEvent(openFeedbackCollectorEventFields(attributes));
    DOMUtils.scrollToDocumentTop();
    setFeedbackCollectorOpen(true);
  };
  const onFeedbackClose = () => setFeedbackCollectorOpen(false);
  const displayFlag = () => {
    fireAnalyticsEvent(submitFeedbackCollectorEventFields(attributes));
    setFlagOpen(true);
  };
  const hideFlag = () => setFlagOpen(false);
  const descriptionText = enableAppificationChanges() ? 'Your valuable feedback helps us continually improve our Atlassian experiences.' : 'Your valuable feedback helps us continually improve our products.';
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Button, {
      appearance: "link",
      onClick: giveFeedback,
      children: "Give feedback"
    }), isFeedbackCollectorOpen && /*#__PURE__*/_jsx(AKFeedbackCollector, {
      onClose: onFeedbackClose,
      onSubmit: displayFlag,
      customGatewayUrl: "".concat(mpacBaseUrl, "/gateway/api/"),
      name: userDetails === null || userDetails === void 0 ? void 0 : userDetails.name,
      atlassianAccountId: userDetails === null || userDetails === void 0 ? void 0 : userDetails.accountId,
      entrypointId: ENTRYPOINT_ID,
      feedbackTitleDetails: /*#__PURE__*/_jsx(FeedbackPreamble, {}),
      shouldGetEntitlementDetails: false,
      feedbackTitle: "Share feedback",
      cancelButtonLabel: "Cancel",
      submitButtonLabel: "Share Feedback",
      additionalFields: additionalFields
    }), /*#__PURE__*/_jsx(FlagGroup, {
      onDismissed: hideFlag,
      children: isFlagOpen && /*#__PURE__*/_jsx(AutoDismissFlag, {
        icon: /*#__PURE__*/_jsx(SuccessIcon, {
          primaryColor: "var(--ds-icon-success, #22A06B)",
          label: "Success",
          size: "medium"
        }),
        title: "Thanks!",
        description: descriptionText,
        id: "partner-feedback-flag"
      })
    })]
  });
};
export default PartnerFeedback;